import { render, staticRenderFns } from "./Erc721TransationList.vue?vue&type=template&id=72619f91&"
import script from "./Erc721TransationList.vue?vue&type=script&lang=js&"
export * from "./Erc721TransationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports